export default __webpack_public_path__ + "static/media/phone.9b43c6e2.svg";